import {DashboardResponse} from './types';
import {useMutation, useQuery} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {getFormattedTimeZone} from '@/Utils/CommonUtils';

export default function useDashboardApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const mutation = useMutation<DashboardResponse, Error, void>(
    async () => {
      const user_timezone = getFormattedTimeZone(false, true);
      const response = await ChessRestClient.get('dashboard/v1/summary/', {
        params: {
          website: 'learning',
          user_timezone: user_timezone,
        },
        headers: {Accept: 'text/event-stream'},
      });
      console.log(response.data);
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess && data.success) handleOnSuccess(data);
        else if (handleOnError) handleOnError(data);
      },
    },
  );

  return {
    ...mutation,
  };
}

export function useDashboardApiQuery(opts) {
  return useQuery({
    enabled: opts?.enabled || true,
    queryKey: ['dashboard'],
    queryFn: async () => {
      const response = await ChessRestClient.get(
        'dashboard/v1/summary/?website=learning',
        {
          headers: {Accept: 'text/event-stream'},
        },
      );
      return response.data.data;
    },
  });
}
